import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#18181b] group-[.toaster]:text-[#fafafa] group-[.toaster]:border group-[.toaster]:border-[#27272a] group-[.toaster]:rounded-md group-[.toaster]:shadow-[0_10px_30px_-10px_rgba(0,0,0,0.6)] group-[.toaster]:font-[Geist,system-ui,sans-serif] group-[.toaster]:text-[13px]",
          title: "group-[.toast]:text-[#fafafa] group-[.toast]:font-medium",
          description: "group-[.toast]:text-[#a1a1aa] group-[.toast]:text-[12px]",
          actionButton:
            "group-[.toast]:bg-[#FE7105] group-[.toast]:text-white group-[.toast]:hover:brightness-110 group-[.toast]:rounded-md group-[.toast]:h-7 group-[.toast]:px-2.5 group-[.toast]:text-xs group-[.toast]:font-medium",
          cancelButton:
            "group-[.toast]:bg-[#27272a] group-[.toast]:text-[#a1a1aa] group-[.toast]:hover:bg-[#2f2f33] group-[.toast]:rounded-md group-[.toast]:h-7 group-[.toast]:px-2.5 group-[.toast]:text-xs group-[.toast]:font-medium",
          closeButton:
            "group-[.toast]:bg-[#18181b] group-[.toast]:border-[#27272a] group-[.toast]:text-[#a1a1aa] group-[.toast]:hover:bg-[#27272a] group-[.toast]:hover:text-[#fafafa]",
          success:
            "group toast group-[.toaster]:bg-[#18181b] group-[.toaster]:border-[#27272a] [&>[data-icon]]:text-emerald-400 [&>[data-icon]>svg]:fill-emerald-400/20",
          error:
            "group toast group-[.toaster]:bg-[#18181b] group-[.toaster]:border-[#27272a] [&>[data-icon]]:text-red-400 [&>[data-icon]>svg]:fill-red-400/20",
          warning:
            "group toast group-[.toaster]:bg-[#18181b] group-[.toaster]:border-[#27272a] [&>[data-icon]]:text-yellow-400 [&>[data-icon]>svg]:fill-yellow-400/20",
          info:
            "group toast group-[.toaster]:bg-[#18181b] group-[.toaster]:border-[#27272a] [&>[data-icon]]:text-blue-400 [&>[data-icon]>svg]:fill-blue-400/20",
          loader: "group-[.toast]:text-[#FE7105]",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
